<template>
  <div class="plan">
    <AppWithLoading :fetch="update" v-slot:default="{loader}">
      <template v-if="discount">
        <div class="discount">
          <div class="plan__discount">
            <div>{{ $t('discount3') }}.</div>
            {{ $t('discount1') }}
            <span>{{ discount }}%</span>
            {{ $t('discount2') }}.
          </div>
          <div class="plan__discount_text">
            {{ $t('discountText') }}.
          </div>
        </div>
      </template>
      <template>
        <h2 class="plan__title">
          {{ $t('plans') }}
        </h2>
        <div v-if="account.trialAvailable && !isExpired" class="plan__text">
          {{ $t('choosePlanThatSuits') }}
        </div>
        <table class="plan-table">
          <thead>
            <tr class="plan-table__header">
              <th class="plan-table__header-item">
                <br>
              </th>
              <th class="plan-table__header-item" colspan="2">
                <span>{{ $t('price') }}</span>
              </th>
              <th class="plan-table__header-item">
                <span>{{ $t('feedbacks') }}</span>
              </th>
              <th class="plan-table__header-item">
                <span>{{ $t('sms') }}</span>
              </th>
              <th class="plan-table__header-item">
                <span>{{ $t('calls') }}</span>
              </th>

              <th class="plan-table__header-item">
                <span>{{ $t('aiQuestions') }}</span>
              </th>
              <th class="plan-table__header-item">
                <span>{{ $t('unlimitedVacancies') }}</span>
              </th>
              <th class="plan-table__header-item">
                <span>{{ $t('recordingOnlineInterview') }}</span>
              </th>
              <th class="plan-table__header-item">
                <span>{{ $t('recordingFaceInterview') }}</span>
              </th>
              <th class="plan-table__header-item">
                <span>{{ $t('paymentCard') }}</span>
              </th>

              <th class="plan-table__header-item">
                <span>{{ $t('career-portal') }}</span>
              </th>
              <th class="plan-table__header-item">
                <span>{{ $t('multiuser') }}</span>
              </th>
              <th class="plan-table__header-item">
                <span>{{ $t('transcriptionAi') }}</span>
              </th>
              <th class="plan-table__header-item">
                <span>{{ $t('reviewAi') }}</span>
              </th>
              <th class="plan-table__header-item">
                <span>{{ $t('scoreAi') }}</span>
              </th>

              <th class="plan-table__header-item" colspan="2">
                <br>
              </th>
            </tr>
          </thead>

          <tbody v-if="plans" class="plan-table__body">
            <PaymentPlanItem
              :period="period"
              v-for="(planItem, index) of plans"
              :key="planItem.id"
              :index="index"
              :payment-plan="planItem"
              @fetchData="loader(() => update())"
              @tryPlan="tryPlan(planItem.id)"
            />
          </tbody>
        </table>
      </template>
      <ul class="rules mt-5 mb-10">
        <li v-if="account.trialAvailable && !isExpired">
          {{ $t('endTrialPeriod') }}
        </li>
        <li :key="index" v-for="(rule,index) in $t('rules')">
          {{ rule }}
        </li>
      </ul>
      <!--      TODO: убрать v-if="false" когда квоты будут готовы #ADD_QUOTA-->
      <template v-if="false">
        <h2 class="plan__title">
          {{ $t('quotas') }}
        </h2>
        <PlanQuotaItems />
      </template>
    </AppWithLoading>
    <AppDialog
      v-model="dialogPaymentStripe"
      max-width="900px"
    >
      <VCard class="pa-8">
        <PaymentMethodCardStripeAdd
          @closeDialogStripe="closeDialogStripe()"
          :dialog-payment-stripe="dialogPaymentStripe"
          :is-trial-try="isTrialTry"
          :current-trial-plan-id="currentTrialPlanId"
        />
      </VCard>
    </AppDialog>
  </div>
</template>

<script>
import AppDialog from '@/components/AppDialog.vue';
import usePlan from '@/compositions/accounting/usePlan';
import PaymentPlanItem from '@/components/Payment/Plans/PaymentPlanItem';
import {
  ref, watchEffect, computed, onMounted,
} from '@vue/composition-api';
import usePeriod from '@/compositions/accounting/usePeriod';
import useAccount from '@/compositions/accounting/useAccount';
import usePayment from '@/compositions/accounting/usePayment';
import AppWithLoading from '@/components/AppWithLoading';
import PlanQuotaItems from '@/components/Payment/Plans/PlanQuotaItems';
import { useI18n } from 'vue-i18n-composable';
import { settingsTabs, paymentTabs, paymentDrivers } from '@/enums';
import PaymentMethodCardStripeAdd from '@/components/Payment/Methods/PaymentMethodCardStripeAdd';
import useSubscription from '@/compositions/accounting/useSubscription';
import useDiscount from '@/compositions/useDiscount';

export default {
  name: 'PaymentPlans',
  components: {
    AppDialog,
    PlanQuotaItems,
    AppWithLoading,
    PaymentPlanItem,
    PaymentMethodCardStripeAdd,
  },
  setup() {
    const { fetchAll, sortedPlans } = usePlan();
    const { fetch, periods } = usePeriod();
    const { account, fetch: fetchAccount } = useAccount();
    const { discountInfo, fetchDiscountInfo } = useDiscount();
    const { paymentDialog } = usePayment();
    const { isExpired } = useSubscription();
    const { locale } = useI18n();
    const period = ref(null);
    const dialogPaymentStripe = ref(false);
    const isTrialTry = ref(false);
    const currentTrialPlanId = ref(null);

    async function update() {
      await fetchAccount();
      await fetch();
      await fetchAll();
    }

    const plans = computed(() => {
      if (locale.value === 'en') {
        sortedPlans.value.map((plan) => {
          if (plan.title === 'Start') return sortedPlans.value - sortedPlans.value.splice(1, 1);
        });
      }
      return sortedPlans.value;
    });

    const discount = computed(() => discountInfo.value[0]?.discount);

    watchEffect(() => {
      if (!period.value) {
        period.value = periods.value.find((p) => p.default);
      }
    });

    function tryPlan(planId) {
      isTrialTry.value = true;
      currentTrialPlanId.value = planId;
      dialogPaymentStripe.value = true;
    }

    function closeDialogStripe() {
      dialogPaymentStripe.value = false;
    }

    onMounted(async () => {
      await fetchDiscountInfo();
    });

    return {
      plans,
      period,
      paymentDialog,
      update,
      paymentTabs,
      settingsTabs,
      account,
      paymentDrivers,
      dialogPaymentStripe,
      tryPlan,
      isTrialTry,
      closeDialogStripe,
      isExpired,
      discount,
      currentTrialPlanId,
    };
  },
};
</script>

<style lang="scss" scoped>

.plan {
  padding: 2.1875rem 2.5rem 2.5rem 2.5rem;
  @media screen and (max-width: 599px) {
    padding: 2.1875rem 0 2.5rem 0;
  }
  &__title {
    font-size: 1.5rem;
    line-height: 1.2;
    font-weight: 400;
    color: #212121;
    margin-bottom: 0.625rem;
    @media screen and (max-width: 428px) {
      font-size: 18px;
    }
  }
  &__text {
    font-size: 17px;
    line-height: 26px;
    color: #091A35;
    opacity: 0.7;
    margin-bottom: 1.25rem;
    @media screen and (max-width: 428px) {
      font-size: 14px;
      line-height: 16.8px;
    }
  }
  &__discount {
    font-size: 17px;
    line-height: 17px;
    display: inline-block;
    color: #212121;
    margin-bottom: 5px;
    @media screen and (max-width: 599px) {
      font-size: 14px;
      line-height: 14px;
    }
    @media screen and (max-width: 428px) {
      display: block;
    }
    span {
      color: #0A82D9;
    }
    div {
      padding-bottom: 2px;
    }
    &_text {
      color: #212121;
      font-size: 14px;
      font-weight: 300;
      line-height: 14px;
      @media screen and (max-width: 428px) {
        font-size: 14px;
        line-height: 14px;
      }
    }
  }
}
.plan-table {
  display: flex;
  width: 100%;
  &__header-item {
    font-weight: 300;
    font-size: 16px;
    line-height: 19px;
    color: #000000;
    text-align: left;
    border-bottom: 1px solid #EEEEEE;
    min-height: 70px;
    display: flex;
    align-items: center;
    width: 100%;
    @media screen and (max-width: 599px) {
      padding: 10px;
    }
  }
  &__header {
    min-width: 240px;
    th:nth-child(1), th:nth-child(16) {
      border-bottom: none;
    }
    @media screen and (max-width: 599px) {
      min-width: 190px;
    }
  }
  &__body {
    display: flex;
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
  }
}

.discount {
  margin-bottom: 40px;
}

tr { display: block; float: left; }
th, td { display: block; }
</style>
<style lang="scss">
  .plan-table__header-item:last-child td {
    border: none;
  }
</style>

<i18n lang="yml" locale="ru">
plans: Тарифы
plan: Тариф
choosePlanThatSuits: Чтобы ознакомиться со всеми возможностями Huntica, вы можете активировать пробный период на один месяц бесплатно
feedbacks: Отклики
sms: СМС
calls: Звонки
price: Стоимость в месяц
quotas: Покупка квот
rules:
  1: Неиспользованные отклики, начисленные согласно тарифному плану тратятся на открытие откликов из предыдущих периодов. Остаток сгорает полностью.
  2: Отклик за кандидата списывается в момент просмотра автоматического интервью, создания офисного интервью, видеозвонка или загрузки своего видео.
  3: При списании отклика за кандидата все последующие активности в карточке этого кандидата бесплатны. Например после автоматического интервью можно записать видеозвонок. Новый отклик списан не будет.
multiuser: Многопользовательский кабинет
career-portal: Карьерный портал
unlimitedVacancies: Количество активных вакансий
aiQuestions: Подбор и озвучивание вопросов от ИИ
recordingOnlineInterview: Запись онлайн интервью
recordingFaceInterview: Запись очного интервью
paymentCard: Оплата банковской картой
endTrialPeriod: При окончании пробного периода, с Вашей карты автоматически спишется сумма за следующий месяц.
transcriptionAi: Транскрипция интервью от ИИ
reviewAi: Рецензия от ИИ
scoreAi: Оценка кандидата от ИИ
discountText: Скидка применяется только в первый месяц оплаты тарифа
discount: Скидка
discount1: 'Для вас действует скидка'
discount2: 'на первую оплату любого тарифа'
discount3: 'Вы воспользовались реферальной ссылкой'
</i18n>
<i18n lang="yml" locale="en">
plans: Plans
plan: Plan
choosePlanThatSuits: To get acquainted with all the features of Huntica, you can activate a one-month trial period for free
feedbacks: Interviews
sms: Text messages
calls: Calls
price: Price per month
quotas: Buying Quotas
rules:
  1: You will be charged for a “candidate response” when you view an automated interview, create an office interview, make a video call, or upload your own video.
  2: "Once you select a response from a candidate, all subsequent activity on that candidate's page is free. For example, you can record a video call after you view an automated interview. Additional payment for a new response will not be deducted."
multiuser: Multi-user mode
career-portal: Career portal
unlimitedVacancies: Number of active jobs
aiQuestions: Selection and dubbing questions from AI
recordingOnlineInterview: Recording an online interview
recordingFaceInterview: Recording a face-to-face interview
paymentCard: Payment by bank card
endTrialPeriod: At the end of the trial period, the amount for the next month will be automatically debited from your card.
transcriptionAi: Transcript of the interview from AI
reviewAi: Review from AI
scoreAi: Candidate Evaluation from AI
discountText: The discount applies to only the first month of payment of the tariff
discount: Discount
discount1: 'There is a'
discount2: 'discount for you on the first payment of any tariff'
discount3: 'You used a referral link'
</i18n>
